
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { postAntManageList, getAntManageList } from '@/api/antManage/antManage'

@Component({
  name: 'basicInformation',
  components: {}
})
export default class extends Vue {
  // @Prop() master!: any

  private infoForm: any = {
    username: '',
    password: '',
    ant_type: 'trader',
    status: 1
    // invitation_code: ''
    // ancestor: ''
  }
  private loading = false
  private rules:any = {
    username: [
      { required: true, message: 'Please enter account ID', trigger: 'blur' }
    ],
    password: [
      { required: true, message: 'Please enter password', trigger: 'blur' }
    ],
    ant_type: [
      { required: true, message: 'Please enter ant_type', trigger: 'blur' }
    ],
    ancestor: [
      { required: true, message: 'Please enter ancestor', trigger: 'blur' }
    ]
  }

  private master:any = []
  private loadingList = false
  private async remoteMethod (query) {
    try {
      this.loadingList = true
      const data: any = {
        ant_type: 'master',
        name: query,
        page_size: 100
      }
      await getAntManageList(data).then((res: any) => {
        this.master = res.results
        this.loadingList = false
      })
    } catch (e) {
      this.loadingList = false
    }
  }
  private masterList: any[] = []
  private listLoading = false
  // 对所有数据进行分页处理 发送请求
  private async getMasterList(name) {
    try {
      this.listLoading = true
      const data: any = {
        name: name,
        page_size: 100,
        page: 1
      }
      await getAntManageList(data).then((res: any) => {
        this.masterList = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }
  private back () {
    this.infoForm = {
      username: '',
      password: '',
      ant_type: 'trader',
      status: 1
    // invitation_code: ''
    // ancestor: ''
    }
    this.$emit('close', false)
  }
  private isShow:boolean = true
  private isFocus:boolean = false
  private onFocus (val) {
    if (val) {
      this.isFocus = true
    } else {
      this.isFocus = false
    }
  }
  private onSubmit() {
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        if (this.infoForm.ant_type === 'sub' && this.infoForm.ancestor === '') return this.$message.error('Ancestor cannot be null')
        try {
          this.loading = true
          await postAntManageList(this.infoForm).then(() => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.loading = false
            this.back()
          })
        } catch (e) {
          this.back()
          this.loading = false
        }
      } else {
        return false
      }
    })
  }
}
